var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationfooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 23,
    viewBox: "0 0 15 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5637 21.2998C11.4099 15.9152 14.4868 11.2998 14.4868 8.22288C14.4868 6.38677 13.7574 4.62586 12.4591 3.32753C11.1607 2.0292 9.39982 1.2998 7.5637 1.2998C5.72759 1.2998 3.96668 2.0292 2.66835 3.32753C1.37002 4.62586 0.640625 6.38677 0.640625 8.22288C0.640625 11.2998 3.71755 15.9152 7.5637 21.2998Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6402 8.22341C10.6402 9.03946 10.316 9.82209 9.73896 10.3991C9.16193 10.9762 8.3793 11.3003 7.56325 11.3003C6.7472 11.3003 5.96457 10.9762 5.38754 10.3991C4.8105 9.82209 4.48633 9.03946 4.48633 8.22341C4.48633 7.40736 4.8105 6.62473 5.38754 6.04769C5.96457 5.47066 6.7472 5.14648 7.56325 5.14648C8.3793 5.14648 9.16193 5.47066 9.73896 6.04769C10.316 6.62473 10.6402 7.40736 10.6402 8.22341Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationfooter);
export default __webpack_public_path__ + "static/media/locationfooter.e4541275af85eb9071508befff31c082.svg";
export { ForwardRef as ReactComponent };